export default "__VITE_ASSET__bd49a479__"